import ExperimentKey from "../../Experiment/types/ExperimentKey";
import ExperimentalFlowResolver from "../types/ExperimentalFlowResolver";
import { Flow } from "../types/IFlow";
import { NoConfirmationRebookFlowLegacyNames } from "../types/FlowNames";
import {
  SingleMedicalStepDefaultNavigatorConfiguration,
  SingleMedicalStepPreQualifiedPatientNavigatorConfiguration
} from "./NavigatorConfigurations";
import NoConfirmationRebookFlow, { PreQualifiedNoConfirmationRebookFlow } from "./NoConfirmationRebookFlow";
import {
  experimentalScreeningStepConfigurations,
  noConfirmationStaticCenterBookingStepConfigurations
} from "./StepConfigurations";

const singleMedicalStepRebookFlowName = "SingleMedicalStepRebookFlow";

/** The treatment flow where a rebook guest experiences the single-page medical presentation. */
class SingleMedicalStepRebookFlow extends Flow {
  static readonly flowName = singleMedicalStepRebookFlowName;
  readonly name = singleMedicalStepRebookFlowName;
  readonly steps = {
    ...experimentalScreeningStepConfigurations,
    ...noConfirmationStaticCenterBookingStepConfigurations
  };
  readonly navigatorItems = [...SingleMedicalStepDefaultNavigatorConfiguration];
  isDisqualificationPossible() {
    return true;
  }
  override matchesFlowName(name: string): boolean {
    return this.name === name || NoConfirmationRebookFlowLegacyNames.includes(name);
  }
}

/** The treatment flow for pre-qualified rebook guests (scheduling-only path). */
export class PreQualifiedSingleMedicalStepRebookFlow extends Flow {
  readonly name = singleMedicalStepRebookFlowName;
  readonly steps = { ...noConfirmationStaticCenterBookingStepConfigurations };
  readonly navigatorItems = [...SingleMedicalStepPreQualifiedPatientNavigatorConfiguration];
  isDisqualificationPossible() {
    return false;
  }
  override matchesFlowName(name: string): boolean {
    return this.name === name || NoConfirmationRebookFlowLegacyNames.includes(name);
  }
}

export default SingleMedicalStepRebookFlow;

/** Resolves rebook flows through the single-medical-step experiment when the session flow name matches the control family. */
export const SingleMedicalStepRebookFlowResolver = new ExperimentalFlowResolver(
  new SingleMedicalStepRebookFlow(),
  new NoConfirmationRebookFlow(),
  ExperimentKey.SingleMedicalStepFlow
);

/** Resolves pre-qualified rebook flows through the single-medical-step experiment. */
export const PreQualifiedSingleMedicalStepRebookFlowResolver = new ExperimentalFlowResolver(
  new PreQualifiedSingleMedicalStepRebookFlow(),
  new PreQualifiedNoConfirmationRebookFlow(),
  ExperimentKey.SingleMedicalStepFlow
);
